import {IconButton, alpha, css, styled} from '@mui/material';
import {StyledContainerProps, StyledProps} from './types';

const StyledIconButton = styled(IconButton)`
	background-color: ${({theme}) => alpha(theme.palette.common.black, 0.3)};
	color: ${({theme}) => theme.palette.common.white};

	&.Mui-disabled {
		display: none;
	}

	&:hover {
		background-color: ${({theme}) => theme.palette.action.active};
	}
`;

const ArrowsContainer = styled('div')`
	width: 100%;
	position: absolute;
	top: 50%;
`;

const ArrowsAnchor = styled('div')`
	width: 100%;
	position: relative;
	z-index: 2;

	button:nth-child(1) {
		position: absolute;
		left: 4px;
		transform: translateY(-50%);
	}

	button:nth-child(2) {
		position: absolute;
		right: 4px;
		transform: translateY(-50%);
	}
`;

const DotsContainer = styled('div')<StyledContainerProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	padding-inline: 24px;
	margin-top: ${({$hideButtons}) => ($hideButtons ? 16 : 8)}px;
`;

const StyledDotButton = styled('button')<StyledProps>`
	background-color: ${({theme, $isActive}) =>
		$isActive ? theme.palette.primary.main : theme.palette.action.disabled};
	width: 8px;
	height: 8px;
	border-radius: 50%;
	transition: all 0.2s ease-in;

	${({theme, $isDarkTheme, $isActive}) =>
		$isDarkTheme &&
		css`
			background-color: ${$isActive
				? theme.palette.other.progressBar
				: alpha(theme.palette.common.white, 0.3)};
		`}
`;

export {StyledIconButton, ArrowsContainer, ArrowsAnchor, DotsContainer, StyledDotButton};
